import React from 'react';
import { ChevronDown, Zap, Shield, TrendingUp, Car } from 'lucide-react';
import { Button } from '../ui/button';
import { heroData } from '../../data/mock';

const Hero = () => {
  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.image}
          alt="LUCARS Movilidad"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/90 via-gray-900/70 to-gray-900/90"></div>
        {/* Accent gradient */}
        <div className="absolute inset-0 bg-gradient-to-tr from-[#63E61E]/20 via-transparent to-transparent"></div>
      </div>

      {/* Floating elements animation */}
      <div className="absolute inset-0 z-10">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#63E61E]/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#63E61E]/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-20 text-center">
        <div className="max-w-5xl mx-auto space-y-8 pt-20">
          {/* Logo Grande */}
          <div className="space-y-6 animate-fadeIn">
            <div className="flex justify-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_responsive-design-68/artifacts/pi8nnphe_LUCARS_LOGO.png" 
                alt="LUCARS - Siempre en Movimiento" 
                className="h-48 md:h-64 lg:h-80 w-auto object-contain drop-shadow-2xl"
                style={{ filter: 'drop-shadow(0 0 60px rgba(99, 230, 30, 0.3))' }}
              />
            </div>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl lg:text-2xl text-gray-200 max-w-3xl mx-auto leading-relaxed">
            {heroData.description}
          </p>

          {/* Features Grid - Solo 2 tarjetas */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto pt-8">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
              <Car className="w-10 h-10 text-[#63E61E] mx-auto mb-3" />
              <h3 className="text-white font-bold text-lg mb-2">Autos a Gasolina</h3>
              <p className="text-gray-300 text-sm">Vehículos confiables y eficientes</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 hover:scale-105">
              <Zap className="w-10 h-10 text-[#63E61E] mx-auto mb-3" />
              <h3 className="text-white font-bold text-lg mb-2">Autos Eléctricos</h3>
              <p className="text-gray-300 text-sm">Tecnología limpia y sustentable</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button
              onClick={scrollToAbout}
              className="bg-[#63E61E] hover:bg-[#52c518] text-gray-900 font-bold text-lg px-8 py-6 rounded-full transition-all duration-300 shadow-2xl hover:shadow-[#63E61E]/50 hover:scale-105"
            >
              Conocer Más
            </Button>
            <Button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 font-bold text-lg px-8 py-6 rounded-full transition-all duration-300"
            >
              Contáctanos
            </Button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-8 h-8 text-[#63E61E]" />
        </div>
      </div>
    </section>
  );
};

export default Hero;